import { Component } from '@angular/core';
import { ProductMenuHeaderComponent } from '../../product-menu-header.component';

@Component({
  selector: 'app-menu-header-left-logo-right-desc-and-image',
  templateUrl: './menu-header-left-logo-right-desc-and-image.component.html',
  styleUrls: ['./menu-header-left-logo-right-desc-and-image.component.scss'],
  providers: [{ provide: ProductMenuHeaderComponent, useExisting: MenuHeaderLeftLogoRightDescAndImageComponent }],
  standalone: false
})
export class MenuHeaderLeftLogoRightDescAndImageComponent extends ProductMenuHeaderComponent {}
